import { FormDataPerfil, FormDataVehicle } from 'utils/typeServices';

type Params = {
    FormDataPerfil: FormDataPerfil;
    FormDataVehicle: FormDataVehicle;
    newVersionQarActive: boolean;
}

type ParamsDsPerfil = {
    key: string;
    value: string;
}

const PROFILE_V2_ONLY_KEYS = ["tipo_veiculo", "atividade_veiculo", "veiculo_blindado", "veiculo_rebaixado", "veiculo_tunado"];

export const ParsePerfilQuotation = ({ FormDataPerfil, FormDataVehicle, newVersionQarActive }: Params) => {
    const datePerfil: Array<ParamsDsPerfil> = [
        {
            key: "nascimento_segurado",
            value: FormDataPerfil.birthData,
        },
        {
            key: "sexo_segurado",
            value: FormDataPerfil.sex.value,
        },
        {
            key: "estado_civil_segurado",
            value: FormDataPerfil.civilStatus.value,
        },
        {
            key: "condutor_menor_26",
            value: FormDataVehicle.minimumAge === "Sim" ? "1" : "0",
        },
        {
            key: "garagem_fechada",
            value: FormDataVehicle.keptInGarage === "Sim" ? "1" : "0",
        },
        {
            key: "garagem_residencia",
            value: FormDataVehicle.keptInGarage === "Sim" ? FormDataVehicle.atHome ? "1" : "0" : "0",
        },
        {
            key: "garagem_trabalho",
            value: FormDataVehicle.vehicleUse.value === 'comercial' ? '2' : FormDataVehicle.transportToWork === "Não" ? '2' : FormDataVehicle.keptInGarage === "Sim" ? FormDataVehicle.atWork : '0',
        },
        {
            key: "garagem_faculdade",
            value: FormDataVehicle.keptInGarage === "Sim" ? FormDataVehicle.atSchoolOrcollege || "0" : "0",
        },
        {
            key: "transporte_trabalho",
            value: FormDataVehicle.transportToWork === "Sim" ? "1" : "0",
        },
        {
            key: "finalidade_uso_veiculo",
            value: FormDataVehicle.vehicleUse.value,
        },
        {
            key: "tipo_veiculo",
            value: FormDataVehicle.vehicleType?.value || "",
        },
        {
            key: "atividade_veiculo",
            value: FormDataVehicle.vehicleActivity?.value || "",
        },
        {
            key: "segurado_principal_condutor",
            value: FormDataVehicle.mainConductor === "Sim" ? "1" : "0",
        },
        {
            key: "segurado_proprietario_legal",
            value: FormDataVehicle.safeOwnerVehicle === "Sim" ? "1" : FormDataVehicle.safeOwnerVehicle === "Não" ? "0" : "",
        },
        {
            key: "cpf_condutor",
            value: FormDataVehicle.identityConductor || "",
        },
        {
            key: "nome_condutor",
            value: FormDataVehicle.nameConductor || "",
        },
        {
            key: "data_nascimento_condutor",
            value: FormDataVehicle.birthDataConductor || "",
        },
        {
            key: "sexo_condutor",
            value: FormDataVehicle.sexConductor?.value || '',
        },
        {
            key: "estado_civil_condutor",
            value: FormDataVehicle.civilStatusConductor?.value || '',
        },
        {
            key: "vinculo_condutor_segurado",
            value: FormDataVehicle.insuredBond?.value || '',
        },
        {
            key: "tempo_habilitacao",
            value: FormDataVehicle.licenseTime === "Até 2 anos" ? "2_anos" : "mais_2_anos",
        },
        {
            key: "veiculo_blindado",
            value: FormDataVehicle.vehicleArmored ? "1" : "0",
        },
        {
            key: "veiculo_rebaixado",
            value: FormDataVehicle.vehicleLowered ? "1" : "0",
        },
        {
            key: "veiculo_tunado",
            value: FormDataVehicle.vehicleTuned ? "1" : "0",
        },
        {
            key: "isencao_imposto",
            value: FormDataVehicle.exemptionImpostor === "Sim" ? "1" : "0",
        },
        {
            key: "zero_km",
            value: FormDataVehicle.newCar === "Sim" ? "1" : "0",
        },
        {
            key: "saida_concessionaria",
            value: FormDataVehicle.newCar === "Sim" ? FormDataVehicle.departureDealership ? FormDataVehicle.departureDealership : "" : "",
        },
        {
            key: "veiculo_kit_gas",
            value: FormDataVehicle.gasKit === "Sim" ? "1" : "0",
        },
        {
            key: "motivo_isencao_fiscal",
            value: FormDataVehicle.taxExemptionReason?.value || '',
        }
    ];

    if (!newVersionQarActive) {
        return [
            ...datePerfil.filter(({ key }) => !PROFILE_V2_ONLY_KEYS.includes(key)),
            {
                key: "veiculo_modificado",
                value: FormDataVehicle.equipped === "Sim" ? "1" : "0",
            },
        ];
    }

    return datePerfil;
}

// zero_km: parseStringToNumber(FormDataVehicle.newCar),
// zveiculo_modificado: parseStringToNumber(FormDataVehicle.equipped),
// isencao_imposto: parseStringToNumber(FormDataVehicle.exemptionImpostor),
// finalidade_uso_veiculo: FormDataVehicle.vehicleUse.value,
// nascimento_segurado: new Date(`${FormDataPerfil.birthData.split('/')[1]}-${FormDataPerfil.birthData.split('/')[0]}-${FormDataPerfil.birthData.split('/')[2]}`).toISOString(),
// sexo_segurado: FormDataPerfil.sex.value,
// estado_civil_segurado: FormDataPerfil.civilStatus.value,
// tempo_habilitacao: FormDataVehicle.licenseTime === 'Mais de 2 anos' ? 'mais_2_anos' : 'ate_2_anos',
// condutor_menor_26: parseStringToNumber(FormDataVehicle.minimumAge),
// transporte_trabalho: parseStringToNumber(FormDataVehicle.transportToWork),
// garagem_fechada: parseStringToNumber(FormDataVehicle.keptInGarage),
// garagem_residencia: parseStringToNumber(FormDataVehicle.keptInGarage) ? FormDataVehicle.atHome ? 1 : 0 : 0,
// garagem_trabalho: FormDataVehicle.vehicleUse.value === 'comercial' ? 2 : FormDataVehicle.transportToWork === "Não" ? 2 : FormDataVehicle.keptInGarage === "Sim" ? parseFloat(FormDataVehicle.atWork) : 0,
// garagem_faculdade: parseStringToNumber(FormDataVehicle.keptInGarage) ? FormDataVehicle.atSchoolOrcollege ? parseFloat(FormDataVehicle.atSchoolOrcollege) : 0 : 0,
// segurado_proprietario_legal: parseStringToNumber(FormDataVehicle.safeOwnerVehicle),
// segurado_principal_condutor: parseStringToNumber(FormDataVehicle.mainConductor),
// cpf_condutor: FormDataVehicle.identityConductor || '',
// nome_condutor: FormDataVehicle.nameConductor || '',
// data_nascimento_condutor: new Date(`${FormDataPerfil.birthData.split('/')[1]}-${FormDataPerfil.birthData.split('/')[0]}-${FormDataPerfil.birthData.split('/')[2]}`).toISOString(),
// sexo_condutor: FormDataVehicle.sexConductor?.value || '',
// estado_civil_condutor: FormDataVehicle.civilStatusConductor?.value || '',
// vinculo_condutor_segurado: FormDataVehicle.insuredBond?.value || '',
// saida_concessionaria: new Date(`${FormDataPerfil.birthData.split('/')[1]}-${FormDataPerfil.birthData.split('/')[0]}-${FormDataPerfil.birthData.split('/')[2]}`).toISOString(),
// veiculo_leilao: 0,
// veiculo_chassi_remarcado: 0,
// veiculo_kit_gas: parseStringToNumber(FormDataVehicle.gasKit),
// motivo_isencao_fiscal: FormDataVehicle.taxExemptionReason?.value || ''